import React from 'react';

export const StarIcon: React.FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = (props) => {
  return <img src="/star.png" alt="star" {...props} />;
};
